import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import useLogout from "../../hooks/useLogout";
import { useForm } from "react-hook-form";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Icon, TooltipComponent } from "../../components/Component";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { Badge } from "reactstrap";
import { listPharmacyAPI, updatePharmacyAPI } from "../../api/pahrmacy";
import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { useNavigate } from "react-router";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import { FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { updateRadius } from "../../api/pahrmacy";

const PharmacyList = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
    },
  });

  const userRole = localStorage.getItem("role")
  const navigate = useNavigate();
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);
  const [radiusModal, setRadiusModal] = useState(false);
  const [selectedPharmacy, setSelectedPharmacy] = useState(null);
  const [radiusValue, setRadiusValue] = useState("");

  const [column, setColumn] = useState([
    {
      name: "Store",
      selector: (row) => row?.store_name,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "6px 0",
          }}
        >
          {/* <img
            onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.store_image)}
            src={row?.store_image ? `${BASE_URL_IMG}${row.store_image}` : "/default-avatar.png"}
            alt={row?.store_name || "Store"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          /> */}
          <UserAvatarCell
            row={row}
            name={row?.store_name}
            handleImageOpenPreview={handleImageOpenPreview}
            image={`${BASE_URL_IMG}${row.store_image}`}
          />

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                // fontWeight: 600,
                // fontSize: "15px",
                color: "#111827",
                lineHeight: "1.2",
              }}
            >
              {row?.store_name || "N/A"}
            </span>
            <span
              style={{
                // fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {row?.email}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {row?.mobile || row?.contact_number}
            </span>
          </div>
        </div>
      ),
      sortable: true,
      width: "250px",
    },

    {
      name: "Type",
      selector: (row) => row?.store_type,
      selector: (row) => getValue(row?.store_type),
      sortable: true,
    },
    {
      name: "License No",
      selector: (row) => row?.license_no,
      selector: (row) => getValue(row?.license_no),
      sortable: true,
      // width:"150px"
    },
    // {
    //   name: "Address",
    //   selector: (row) => row?.address,
    //   sortable: true,
    //   wrap:true,
    //   // width:"150px"
    // },
    // {
    //   name: "Address",
    //   sortable: true,
    //   wrap: false,
    //   cell: (row) => (
    //     <div
    //       title={row?.address}
    //       style={{
    //         maxWidth: "150px",
    //         whiteSpace: "nowrap",
    //         overflow: "hidden",
    //         textOverflow: "ellipsis",
    //         cursor: "pointer",
    //       }}
    //     >
    //       {row?.address}
    //     </div>
    //   ),
    // },

    {
      name: "Address",
      sortable: true,
      wrap: false,
      cell: (row) => {
        const fullAddress = row?.address || "";

        return (
          <div
            title={fullAddress}
            style={{
              maxWidth: "150px",
              // whiteSpace: "nowrap",
              overflow: "hidden",
              // textOverflow: "ellipsis",
              cursor: "pointer",
            }}
          >
            {truncateByWords(fullAddress, 2)}
          </div>
        );
      },
    },



    {
      name: "Timing",
      selector: (row) => (
        <>
          <div>{row?.end_time ? <span>{row?.start_time + " - " + row?.end_time}</span> : "-"}</div>
        </>
      ),
      selector: (row) => {
        return row?.start_time && row?.end_time
          ? `${row.start_time} - ${row.end_time}`
          : "N/A";
      },
      sortable: true,
      wrap: true,
      // width:"180px"
    },
    {
      name: "KYC",
      selector: (row) => row?.kyc_status,
      cell: (row) => (
        <div
          style={{ cursor: "pointer" }}
        //  onClick={() => handleToggleStatus(row)}
        >
          <Badge
            className="text-capitalize"
            color={`${row.kyc_status == "pending"
              ? "outline-warning"
              : row?.kyc_status == "Approved"
                ? "outline-primary"
                : row?.kyc_status == "In Review"
                  ? "outline-info"
                  : "outline-danger"
              }`}
          >
            {row.kyc_status}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      // width: "80px",
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      // width: "100px",
    },


    {
      name: "Action",
      wrap: true,
      cell: (row) => {
        const isApproved = row?.kyc_status === "Approved";
        const isAdmin = userRole === "admin";
        const isPharmacy = userRole === "pharmacy";
        const canEditPharmacy = isPharmacy && !isApproved;

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",          // spacing between buttons
              flexWrap: "nowrap",  // ❗ prevent going to next line
            }}
          >
            {/* ✅ DASHBOARD */}
            {isApproved && (isAdmin || isPharmacy) && (
              <>
                <Button
                  id={`dash-${row?.id}`}
                  outline
                  color="primary"
                  size="xs"
                  onClick={() => handleGoDashboard(row)}
                >
                  <Icon name="presentation" />
                </Button>

                <TooltipComponent
                  direction="top"
                  id={`dash-${row?.id}`}
                  text="View Pharmacy Dashboard"
                />
              </>
            )}

            {/* ✅ VIEW (ONLY ADMIN) */}
            {isAdmin && (
              <>
                <Button
                  id={`view-${row?.id}`}
                  outline
                  color="success"
                  size="xs"
                  onClick={() => handleShowDetails(row)}
                >
                  <Icon name="eye" />
                </Button>

                <TooltipComponent
                  direction="top"
                  id={`view-${row?.id}`}
                  text="View and Approve Pharmacy"
                />
              </>
            )}

            {/* ✅ EDIT */}
            {/* ✅ EDIT */}
            {canEditPharmacy && (
              <>
                <Button
                  id={`edit-${row?.id}`}
                  outline
                  color="primary"
                  size="xs"
                  onClick={() => handleEditDetails(row)}
                >
                  <Icon name="edit" />
                </Button>

                <TooltipComponent
                  direction="top"
                  id={`edit-${row?.id}`}
                  text="Edit Pharmacy"
                />
              </>
            )}
          </div>
        );
      },
    }
  ]);
  const getValue = (val) => {
    return val !== null && val !== undefined && val !== "" ? val : "N/A";
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const handleGoDashboard = (row) => {
    navigate("/pharmacy-dashboard", { state: { pharmacyId: row?.id, name: row?.store_name } });
  };
  const handleShowDetails = (row) => {
    navigate("/pharmacy-detail", { state: { pharmacyId: row?.id, mode: "Approval" } });
  };
  //   const handleEditDetails = (row) => {
  //   navigate("/pharmacy-update", { state: { pharmacyId: row?.id, mode: "Edit" } });
  // };
  // const handleEditDetails = (row) => {
  //   navigate("/pharmacy-registration/pharmacy-basic-details", { state: { pharmacyId: row?.id, mode: "Edit", isPharmacy: isPharmacy } });
  // };
  const handleEditDetails = (row) => {
    navigate("/details-form-pharmacy", {
      state: {
        pharmacyId: row?.id,
        mode: "Edit",
        isPharmacy: userRole?.toLowerCase() === "pharmacy",
      },
    });
  };
  const handleImageOpenPreview = (row, name) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  useEffect(() => {
    getPharmacyList();
  }, []);

  const getPharmacyList = () => {
    setValue("isLoading", true);
    listPharmacyAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.clearWaitingQueue();
          setData(res.data.data);
          resetForm();
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setData([]);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setValue("isLoading", false);
      });

  };
  const resetForm = () => { };
  const confirmStatusChange = () => {
    const formData = new FormData();
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    formData.append("pharmacy_id", watch("selectedRow")?.id);
    formData.append("status", updatedStatus);

    updatePharmacyAPI(formData).then((res) => {
      if (res.data.status === true) {
        toast.success(res.data.message);
        toast.clearWaitingQueue();
        getPharmacyList();
        setShowModal(false);
      } else if (res.data.status === false) {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
      } else if (res.data.status === "expired") {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
        logout();
      }
    });
  };


  const truncateByWords = (text = "", wordLimit = 5) => {
    if (!text) return "";

    const words = text.trim().split(/\s+/);
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + " ..."
      : text;
  };

  const handleOpenRadiusModal = (row) => {
    setSelectedPharmacy(row);
    setRadiusValue(row?.radius || "");
    setRadiusModal(true);
  };

  const handleSaveRadius = () => {
    if (!radiusValue || radiusValue <= 0) {
      toast.warning("Please enter a valid radius value");
      return;
    }

    const formData = new FormData();
    // formData.append("pharmacy_id", selectedPharmacy?.id);
    formData.append("deliveryRadius", radiusValue);
    formData.append("type", "pharmacy");

    updateRadius(formData)
      .then((res) => {
        if (res.data.status === true) {
          toast.success("Radius updated successfully");
          toast.clearWaitingQueue();
          setRadiusModal(false);
          setRadiusValue("");
          setSelectedPharmacy(null);
          getPharmacyList();
        } else {
          toast.error(res.data.message || "Failed to update radius");
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Error updating radius");
      });
  };

  return (
    <>
      <Head title={"Pharmacy List"} />
      <Content>
        <BlockHead size={`sm`} className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Pharmacy"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="d-flex justify-content-end align-items-center">
                <div className="me-2">
                  <Button
                    color="primary"
                    outline
                    className={`me-n1`}
                    onClick={() => handleOpenRadiusModal(watch("selectedRow"))}
                    // id={`radius-${row?.id}`}
                  >

                    <Icon name=""/> Set Delivery Radius 
                  </Button>

                </div>
                <div className="">

                  <Button
                    color="primary"
                    outline
                    className={`  me-n1`}
                    // onClick={() =>  navigate("/pharmacy-detail")}
                    onClick={() => navigate("/pharmacy-registration/pharmacy-basic-details", { state: { mode: "Add" } })}
                  >
                    <Icon name={isOpen ? "minus" : "plus"} />
                  </Button>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block className="pt-0">
          <MyDataTable title={"Pharmacy List"} isLoading={isLoading} columns={column} data={data || []} />
        </Block>
      </Content>
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        data={watch("selectedRow")}
      />
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />

      <Modal isOpen={radiusModal} toggle={() => setRadiusModal(false)} centered>
        <ModalHeader toggle={() => setRadiusModal(false)}>
          Set Delivery Radius
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="radius-input">
              <strong>Delivery Radius (in KM)</strong>
            </Label>
            <Input
              id="radius-input"
              type="number"
              placeholder="Enter radius in kilometers"
              value={radiusValue}
              onChange={(e) => setRadiusValue(e.target.value)}
              min="1"
              step="1"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setRadiusModal(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleSaveRadius}
          >
            Save Radius
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PharmacyList;
